// ==================================================
//  エラー要素に .error-element クラスを追加
// ==================================================
const mwwpformLabelError = document.querySelectorAll(".mwwpform_label .error");
for (let i = 0; i < mwwpformLabelError.length; i++) {
  mwwpformLabelError[i].previousElementSibling.classList.add("mwwpform_error");
}

// ==================================================
//  プライバシーポリシーのチェックでボタン有効化
// ==================================================
const privacyElement = document.querySelector('input[name="privacy[data][]"]');
const submitButtonElement = document.querySelector(".submitButton-js");
submitButtonElement.classList.remove("submitButton-js-active");
privacyElement.checked = false;
privacyElement.addEventListener("change", () => {
  if (privacyElement.checked) {
    submitButtonElement.classList.add("submitButton-js-active");
  } else {
    submitButtonElement.classList.remove("submitButton-js-active");
  }
});
